import React, { FC } from "react";

import { useIntl } from "react-intl";
import Link from "@material-ui/core/Link";
import CustomOTPCode from "../Ui/CustomOTPCode";
import styles from "./style";
import { useMutation } from "@apollo/client";
import { AccountResult } from "../../graphql/account/types/AccountResult";
import { ResendCodeVariables } from "../../graphql/account/types/ResendCode";
import { RESEND_CODE } from "../../graphql/account/mutation";
import { useToastNotifications } from "../../utils/toastUtils";
import {
  ConfirmCode,
  ConfirmCodeVariables,
} from "../../graphql/onboarding/auth/types/ConfirmCode";
import { CONFIRM_CODE } from "../../graphql/onboarding/auth/mutation";
import { setAccessToken } from "../../services/LocalStorage";
import { useNavigate } from "react-router-dom";

interface IValidationCodeDialogsProps {
  open: boolean;
  email: string;
  handleClose(): void;
}

const ValidationCode: FC<IValidationCodeDialogsProps> = (props) => {
  const intl = useIntl();
  const classes = styles();
  const navigate = useNavigate();
  const { open, handleClose, email } = props;
  const { showErrorToast, showSuccessToast } = useToastNotifications();
  const [sendCode, { loading: sendLoading }] = useMutation<
    AccountResult,
    ResendCodeVariables
  >(RESEND_CODE, {
    onCompleted: () => {
      showSuccessToast({ description: "account.code.send" });
    },
    onError: (error) => {
      const { graphQLErrors, networkError } = error;
      let message = "other.error";
      if (graphQLErrors) message = intl.formatMessage({ id: "server.error" });
      else if (networkError)
        message = intl.formatMessage({ id: "network.error" });

      showErrorToast({
        description: message,
      });
    },
  });

  const [confirmAccount, { loading: confirmLoading }] = useMutation<
    ConfirmCode,
    ConfirmCodeVariables
  >(CONFIRM_CODE, {
    onCompleted: async (data) => {
      if (data?.confirmCode?.accessToken) {
        showSuccessToast({ description: "account.confirm" });
        await setAccessToken(data.confirmCode.accessToken);
        navigate("/step", {
          replace: true,
        });
      } else {
        showErrorToast({
          description: "account.code.notValid",
        });
      }
    },
    onError: (error) => {
      const { graphQLErrors, networkError } = error;
      let message = "other.error";
      if (graphQLErrors) message = intl.formatMessage({ id: "server.error" });
      else if (networkError)
        message = intl.formatMessage({ id: "network.error" });

      showErrorToast({
        description: message,
      });
    },
  });

  const handleSend = () => {
    if (!sendLoading)
      sendCode({
        variables: {
          email,
        },
      });
  };

  const handleCodeConfirm = async (code: string) => {
    confirmAccount({
      variables: {
        code,
        email,
      },
    });
  };

  return (
    <CustomOTPCode
      label={intl.formatMessage({ id: "validate" })}
      title={intl.formatMessage({ id: "dialogue.title" })}
      description={
        <>
          {intl.formatMessage({ id: "dialogue.content" })}{" "}
          <Link className={classes.link} onClick={handleSend}>
            cliquer ici
          </Link>
        </>
      }
      handleValidate={handleCodeConfirm}
      handleClose={handleClose}
      open={open}
      validateLoading={confirmLoading}
    />
  );
};

export default ValidationCode;
